import { GET_GLOBAL_PARAMETERS, GET_GLOBAL_PARAMETERS_ERROR } from "../types/globalParametersType";

const initialState = {
    globalParameters: [],
    globalParamError: null
};

const globalParametersReducer = (state = initialState, action) => {
    const { payload, type } = action;
    switch (type) {
        case GET_GLOBAL_PARAMETERS:
            return {
                ...state,
                globalParameters: payload
            };
        case GET_GLOBAL_PARAMETERS_ERROR:
            return {
                ...state,
                globalParamError: payload
            };
        default:
            return state;
    }
};

export default globalParametersReducer;
